import { ApolloQueryResult } from '@apollo/client';
import { CreditSubmissionDeclineReason } from '@trnsact/trnsact-shared-types';
import { Nullable, SelectOption } from 'global';

export interface DecisionCardFormValues {
  decision: number | null;
  approvedAmount?: number;
  rate?: number;
  notes?: string;
  contingencies?: string;
  creditSubmissionDeclineReason: DeclineReasonOption | null | '';
}

export enum SubmissionDeclineReasonCategory {
  ApplicationRelated = 'Application-Related',
  BusinessProfile = 'Business Profile',
  EquipmentEligibility = 'Equipment Eligibility',
  CreditRisk = 'Credit Risk',
  Other = 'Other',
}

export type DeclineReasonOption = SelectOption & {
  category: SubmissionDeclineReasonCategory;
};

export interface AddEditDeclineReasonDialogFormValues {
  newCategory: string;
  newDeclineReason: string;
  creditSubmissionDeclineReasonsById: Record<string, CreditSubmissionDeclineReason>;
}

export interface AddEditDeclineReasonDialogData {
  creditSubmissionDeclineReasons: CreditSubmissionDeclineReason[];
  refetchCreditSubmissionDeclineReasons: () => Promise<ApolloQueryResult<any>>;
}

export interface CreditSubmissionDeclindeReasonsResponse {
  creditSubmissionDeclineReasons: CreditSubmissionDeclineReason[];
}
